/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConversationFeedbackRequest {
    getFixupPrototypeFunction() { return ConversationFeedbackRequest.fixupPrototype; }

    static newInstance(model: Partial<ConversationFeedbackRequest>): ConversationFeedbackRequest {
        let obj = Object.assign(new ConversationFeedbackRequest(), model);
        ConversationFeedbackRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConversationFeedbackRequest>): ConversationFeedbackRequest {
        if (!model) return null;
        return ConversationFeedbackRequest.newInstance(<ConversationFeedbackRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConversationFeedbackRequest) {
        if (!obj) return;

        models.ConversationFeedbackRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConversationFeedbackRequest): boolean {
        Object.setPrototypeOf(obj, ConversationFeedbackRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rating === undefined) {
            this.rating = 0;
        }
    }

    /**
     * Rating of the query
     */
    rating: number;

}
